import { render, staticRenderFns } from "./OrderViewStatusModal.vue?vue&type=template&id=0176c6d0&"
import script from "./OrderViewStatusModal.vue?vue&type=script&lang=js&"
export * from "./OrderViewStatusModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports